/*eslint-disable*/
import React from "react";
import ReactTable2 from "./ReactTable2";

/**
 * Legacy import path (Tema 1 ve diğer sayfalar).
 * ReactTable2 ile aynı API; alt modern pagination + viewport clamp varsayılan kapalı.
 */
function Table({
  disableViewportClamp = true,
  paginationSelectClassName,
  ...rest
}) {
  return (
    <ReactTable2
      disableViewportClamp={disableViewportClamp}
      paginationSelectClassName={
        paginationSelectClassName ?? "react-select black mx-2 w-100 rt-page-size-select"
      }
      {...rest}
    />
  );
}

export default Table;
